<template>
    <div class="poster-popular-bg">
        <div class="poster-popular-name-wrap">
            <span class="poster-popular-name">
                {{data.doctor_name}}
            </span>
            <span class="poster-popular-dept">{{data.department_name}} | {{data.doctor_position}}</span>
        </div>
        <div class="poster-popular-content">
            <img class="poster-popular-icon" :src="data.doctor_photo" alt="">
            <p class="poster-popular-hospital">{{data.hospital_name}}</p>
            <div class="poster-popular-desc">
                <p>{{data.doctor_intro?data.doctor_intro:'医生还没有填写简介...'}}</p>
                <img class="poster-popular-shadow" src="@/assets/images/doctor/poster_popular_shadow.png" alt="">
            </div>
            <img class="poster-popular-qrcode" :src="data.patient_poster_qrcode" alt="">
            <p class="poster-popular-tips">长按识别二维码</p>
            <p style="margin-bottom: 0.5rem;" class="poster-popular-tips">查看我的主页</p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        props: {
            data: {
                type: Object,
                required: true,
                default: {}
            }
        },
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        },
    }
</script>
<style scoped>
    .poster-popular-bg {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        height: 100%;
        width: 100%;
        background: url(../../assets/images/doctor/poster_bg.png);
    }

    .poster-popular-name-wrap {
        margin-top: 1.9rem;
        margin-left: 5.8rem;
    }

    .poster-popular-name {
        font-size: 0.73rem;
        color: #ffffff;
    }

    .poster-popular-dept {
        margin-left: 0.68rem;
        font-size: 0.43rem;
        color: #ffffff;
    }

    .poster-popular-content {
        display: flex;
        flex-direction: column;
        margin-left: 0.43rem;
        margin-right: 0.43rem;
        height: 18rem;
        background: url(../../assets/images/doctor/poster_popular_widget.png) no-repeat left bottom;
        background-size: 100% 100%;
        padding: 1rem 1.5rem 0 1.5rem;
        position: relative;
        box-sizing: content-box;
    }

    .poster-popular-icon {
        width: 3rem;
        height: 3rem;
        background-color: #ffffff;
        box-shadow: 0rem 0.09rem 0.17rem 0rem rgba(206, 206, 206, 0.4);
        border: solid 0.04rem #ffffff;
        border-radius: 1.5rem;
        position: absolute;
        left: 1.5rem;
        top: -1rem;
    }

    .poster-popular-hospital {
        margin-left: 4rem;
        font-size: 0.43rem;
        color: #222222;
    }

    .poster-popular-desc {
        height: 9rem;
        margin-top: 1.45rem;
        font-size: 0.51rem;
        color: #888888;
        overflow: hidden;
        position: relative;
    }

    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        .poster-popular-desc {
            margin-top: 0;
        }
    }

    .poster-popular-shadow {
        position: absolute;
        width: 100%;
        /* height: 2rem; */
        left: 0;
        bottom: 0;
    }

    .poster-popular-qrcode {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        width: 3.84rem;
        height: 3.84rem;
        align-self: center;
    }

    .poster-popular-tips {
        font-size: 0.51rem;
        color: #ffffff;
        align-self: center;
    }
</style>